export const vistasRouter = [
    {
        path: 'coordination/list',
        name: 'coordination list',
        component: () => import('./pages/list')
    }
]